import React from 'react';
import { Box, Flex } from '@chakra-ui/react';

export const BaseLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex direction="column" height="100%" bg="gray.100" maxW="1700px" m="auto" px={6}>
      <Box flex="1">{children}</Box>
    </Flex>
  );
};
